// src/services/versionService.js
import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

// Which backend build is running: { environment, commit, commitTime, uncommittedChanges, builtAt }.
export const getBackendVersion = async () => {
  const res = await axios.get(`${API_BASE_URL}/api/version`);
  return res.data;
};
